<template>
  <div class="min-h-screen bg-canvas">
    <Notification />
    <AppSidebar />
    <CustomerOffcanvas />

    <!-- Contenido principal — offset del sidebar -->
    <div
      :class="[
        'flex flex-col min-h-screen transition-all duration-300',
        isRenderSideBar ? (sidebarCollapsed ? 'lg:pl-[72px]' : 'lg:pl-[264px]') : '',
      ]">
      <AppHeader />
      <main class="flex-1 px-4 py-6 sm:px-6 lg:px-8">
        <div class="max-w-[1600px] mx-auto">
          <AppBreadcrumb class="mb-4" />
          <router-view />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { computed, getCurrentInstance, onMounted } from 'vue'
import { useStore } from 'vuex'
import { getToken, onMessage } from 'firebase/messaging'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'
import Notification from '@/components/Notification.vue'
import CustomerOffcanvas from '@/components/CustomerOffcanvas.vue'
import AppBreadcrumb from '@/components/AppBreadcrumb.vue'
import { usuarioService } from '@/_services/index.api'

export default {
  name: 'DefaultLayout',
  components: {
    AppHeader,
    AppSidebar,
    Notification,
    CustomerOffcanvas,
    AppBreadcrumb,
  },
  setup() {
    const store = useStore()
    const globalProperties = getCurrentInstance().appContext.config.globalProperties
    const messaging = globalProperties.$messaging

    const isRenderSideBar = computed(() => store.state.isRenderSideBar)
    const sidebarCollapsed = computed(() => store.state.sidebarUnfoldable)

    try {
      getToken(messaging, { vapidKey: process.env.VUE_APP_VAPID_KEY })
        .then(currentToken => {
          if (!currentToken) return
          const currentUser = JSON.parse(localStorage.currentUser)
          usuarioService.updateNoticacionToken({ idUsuario: currentUser.idUsuario, token: currentToken }).catch(() => {})
        })
        .catch(() => {})

      store.dispatch('firsLoadToast')
    } catch {}

    onMounted(() => {
      onMessage(messaging, payload => {
        store.dispatch('addToasts', {
          title: payload.notification.title,
          content: payload.notification.body,
        })
      })
    })

    return { isRenderSideBar, sidebarCollapsed }
  },
}
</script>
